import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const imageNumberLabel = css`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: ${spacing.md}px;
  background-color: var(--neutral-white-base);
  border-radius: 10px;
  padding: 0 8px;
  margin: 0;
  ${responsiveText.BODY.XS};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
